import { Navigate, Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "./components/auth/ProtectedRoute";
import { AppShell } from "./components/layout/AppShell";
import { ResourcePage } from "./components/resources/ResourcePage";
import { LoginPage } from "./pages/LoginPage";
import { DashboardPage } from "./pages/DashboardPage";
import { NotesPage } from "./pages/NotesPage";
import { SearchPage } from "./pages/SearchPage";
import { SpaceLandingPage } from "./pages/SpaceLandingPage";
import { MemoryReviewPage } from "./pages/MemoryReviewPage";
import { AccountSettingsPage, AgentAccessSettingsPage, AppearanceSettingsPage, DataSettingsPage, TrashSettingsPage } from "./pages/SettingsPages";
import { NotFoundPage } from "./pages/NotFoundPage";
import { cardDefinition, personalMemoryDefinition, projectDefinition, purchaseDefinition, reviewDefinition, taskDefinition, toolDefinition, workMemoryDefinition } from "./pages/resourceDefinitions";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<AppShell />}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="work" element={<SpaceLandingPage space="work" />} />
          <Route path="work/tasks" element={<ResourcePage definition={taskDefinition} />} />
          <Route path="work/tasks/:id" element={<ResourcePage definition={taskDefinition} />} />
          <Route path="work/notes" element={<NotesPage kind="work" />} />
          <Route path="work/notes/:id" element={<NotesPage kind="work" />} />
          <Route path="work/memories" element={<ResourcePage definition={workMemoryDefinition} />} />
          <Route path="work/memories/:id" element={<ResourcePage definition={workMemoryDefinition} />} />
          <Route path="work/tools" element={<ResourcePage definition={toolDefinition} />} />
          <Route path="work/tools/:id" element={<ResourcePage definition={toolDefinition} />} />
          <Route path="work/purchases" element={<ResourcePage definition={purchaseDefinition} />} />
          <Route path="work/purchases/:id" element={<ResourcePage definition={purchaseDefinition} />} />
          <Route path="growth" element={<SpaceLandingPage space="growth" />} />
          <Route path="growth/projects" element={<ResourcePage definition={projectDefinition} />} />
          <Route path="growth/projects/:id" element={<ResourcePage definition={projectDefinition} />} />
          <Route path="growth/notes" element={<NotesPage kind="learning" />} />
          <Route path="growth/notes/:id" element={<NotesPage kind="learning" />} />
          <Route path="growth/memories" element={<ResourcePage definition={personalMemoryDefinition} />} />
          <Route path="growth/memories/:id" element={<ResourcePage definition={personalMemoryDefinition} />} />
          <Route path="growth/cards" element={<ResourcePage definition={cardDefinition} />} />
          <Route path="growth/cards/review" element={<MemoryReviewPage />} />
          <Route path="growth/cards/:id" element={<ResourcePage definition={cardDefinition} />} />
          <Route path="growth/reviews" element={<ResourcePage definition={reviewDefinition} />} />
          <Route path="growth/reviews/:id" element={<ResourcePage definition={reviewDefinition} />} />
          <Route path="search" element={<SearchPage />} />
          <Route path="settings" element={<Navigate to="/settings/account" replace />} />
          <Route path="settings/account" element={<AccountSettingsPage />} />
          <Route path="settings/ai-access" element={<AgentAccessSettingsPage />} />
          <Route path="settings/appearance" element={<AppearanceSettingsPage />} />
          <Route path="settings/data" element={<DataSettingsPage />} />
          <Route path="settings/trash" element={<TrashSettingsPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Route>
    </Routes>
  );
}
